<button id="btnModalLightboxCard" data-bs-toggle="modal" data-bs-target="#modalLightBoxCard">
  Click
</button>

<!-- The Modal/Lightbox -->
<div class="modal fade fx-modal" id="modalLightBoxCard" #modal>
  <div class="modal-dialog modal-xl modal-fixed modal-dialog-centered">
    <span class="btn-close cursor" data-bs-dismiss="modal">&times;</span>
    <div class="modal-content">
      <div class="mySlides m-auto" *ngFor="let file of files; let i = index">
        <div class="numbertext">{{ i + 1 }} / {{ files.length }}</div>
        <img src="data:image/jpg;base64,{{ file }}" />
      </div>
      <!-- Next/previous controls -->
      <a class="prev" (click)="plusSlides(-1)">&#10094;</a>
      <a class="next" (click)="plusSlides(1)">&#10095;</a>
    </div>
  </div>
</div>
